import { Drawer, Layout } from "antd";
import { LayoutContext } from "../../../context/LayoutContext";
import { useContext } from "react";
import "./CommonLayout.css";
import CustomSider from "./CustomSider";
import ChatBox from "../../ChatBox/Chatbox";

const { Content } = Layout;

const CommonLayout = ({ children }) => {
    const { collapsed, isMobile, setCollapsed } = useContext(LayoutContext);

    const getMarginLeft = () => {
        if (!isMobile) {
            return !collapsed ? 200 : 75;
        }
        return 0;
    };

    return (
        <Layout
            style={{
                minHeight: "100vh",
                overflow: "hidden", // Prevent body scroll
            }}
        >
            {isMobile ? (
                <Drawer
                    open={!collapsed}
                    onClose={() => setCollapsed(true)}
                    placement="left"
                >
                    <CustomSider />
                </Drawer>
            ) : (
                <CustomSider />
            )}
            <Layout className="site-layout">
                <Content
                    style={{
                        marginLeft: getMarginLeft(),
                        overflow: "hidden", // Changed from "auto"
                        position: "relative",
                        height: "100vh", // Add fixed height
                    }}
                >
                    <div
                        className="site-layout-background"
                        style={{
                            padding: isMobile ? 0 : 24,
                            minHeight: 360,
                            height: "100%", // Take full height
                            overflow: "auto", // Move scroll here
                            overflowX: "hidden", // Prevent horizontal scroll
                        }}
                    >
                        {children}
                        {/* <ChatBox /> //FIXME - Commented due to the expiry of openAI API token */} 
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
};

export { CommonLayout };
